import React from 'react';
import classnames from 'classnames';
import CtaTextWithArrow from '../cta-text-with-arrow';
import ToggleButtonGroup from '../../toggle-button-group';
import PlanDesktop from '../plan-desktop';
const defaultToggle = {
  items: [],
  selectedId: undefined,
  disabled: false,
  fullWidth: false,
};

const defaultCta = {
  text: '',
  promoText: undefined,
  isCompact: false,
};

const PaywallHeader = ({
  isLoading = false,
  isCompact = false,
  isSticky = false,
  plans,
  toggle = defaultToggle,
  cta = defaultCta,
  isHiddenToggle = false,
  withIntroPriceDiscounts = false,
  isCtaVisible = true,
}) => {
  const headerClass = classnames('ws-ui-paywall-header', {
    'ws-ui-paywall-header--is-compact': isCompact,
    'ws-ui-paywall-header--is-sticky': isSticky,
  });
  return (
    <div className={headerClass}>
      <div className="ws-ui-paywall-header__toggle-container">
        {!isHiddenToggle && (
          <div>
            <ToggleButtonGroup {...toggle} fullWidth={isCompact} />
            <div className="ws-ui-paywall-header__cta-wrapper">
              {isCtaVisible && <CtaTextWithArrow {...cta} isCompact={isCompact} />}
            </div>
          </div>
        )}
      </div>
      {!isCompact && (
        <div className="ws-ui-paywall-header__plans">
          {plans.map((item) => (
            <PlanDesktop
              {...item}
              key={item.type}
              isLoading={isLoading}
              withIntroPriceDiscounts={withIntroPriceDiscounts}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PaywallHeader;
